module.exports = __webpack_public_path__ + "static/media/compilacion_solo.e18f4bc.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/compilacion_solo.mp4
// module id = RRdo
// module chunks = 0